// extracted by mini-css-extract-plugin
export default {"block":"ErrorPlug_block__Cr9q-","img":"ErrorPlug_img__zsi7R","text":"ErrorPlug_text__Scke7","link":"ErrorPlug_link__LXiCC"};